import { PropType, computed, defineComponent, ref } from 'vue'

import { CsGallery, CsSecondaryButton, MsHeadline } from '@sunrise/components'
import { MsImage } from '@sunrise/icons'
import { Components } from '@sunrise/types'

import { buildTealiumTracking } from './MsDetailFloorTracking'

export default defineComponent({
    name: 'MsDetailFloorPlan',
    components: {
        CsSecondaryButton,
        CsGallery,
        MsImage,
        MsHeadline,
    },
    props: {
        images: {
            type: Array as PropType<Components.CsGallery.GalleryImage[]>,
            required: true,
        },
        exposeeId: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const galleryVisible = ref<boolean>(false)
        const badgeText = computed(
            () => `${props.images.length} ${props.images.length === 1 ? 'Grundriss' : 'Grundrisse'}`,
        )
        const galleryTracking = buildTealiumTracking(props.exposeeId)

        function openGallery(): void {
            galleryVisible.value = true
        }

        return {
            badgeText,
            galleryVisible,
            galleryTracking,
            openGallery,
        }
    },
})
